import { connect } from 'react-redux';

import { reducer } from 'aws-cognito-redux-saga';

import { userLoginSuccess } from '../../store/actions/login'; // userLoginFailed removed from import, unsure if needed in future.

import SignInComponent from './SignIn';

const mapStateToProps = state => ({
  auth: state.auth,
  // loggedIn: state.loggedIn,
});

const mapDispatchToProps = dispatch => ({
  init: () => {
    dispatch(reducer.init());
  },
  signIn: (username, password, code) => {
    dispatch(reducer.signIn(username, password, code));
  },
  dispatchUserLogin: token => dispatch(userLoginSuccess(token)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignInComponent);
